import classNames from 'classnames';
import { object, shape } from 'prop-types';
import React, { useCallback } from 'react';
import { SkjemaSporsmal } from '../../ahv-schema';
import { PAKREVET_HVIS_FORELDER, SPORSMAL_PAKREVET, BARE_LES_NAR_VALGT } from '../../constants/general';
import { getIsDisabled } from '../../form-util';
import { getPreselected, isRequiredWhenSelected } from '../helper/component-helper';
import connect from '../helper/connect';
import ErrorMessage from '../errormessage';
import DropDown from '../../drop-down';

const DEFAULT_VELG_OPTION_VALUE = '0';

function CountrySelectQuestionType(props) {
    const { question, context, isSubQuestion } = props;
    const { definisjon, instruks, utfyllingsregel, muligeSvar, sporsmalstekst } = question;
    const isRequired =
        (utfyllingsregel &&
            [SPORSMAL_PAKREVET, BARE_LES_NAR_VALGT, PAKREVET_HVIS_FORELDER].includes(utfyllingsregel.regel)) ||
        false;
    const hasInvalidValue = isRequired && context.hasError(definisjon);

    const filterCountryList = (list, predicate = () => true) => {
        const values = [];
        list.filter(predicate).forEach((element) => {
            const { svarId, tekst } = element;
            values.push({ value: svarId, text: tekst });
        });
        return values;
    };

    const getDropDownValues = useCallback(() => {
        if (definisjon === 'PM_STATSBORGERSKAP_SEKUNDART') {
            const selectedCitizenship = context.getValue('PM_STATSBORGERSKAP')[0];
            return filterCountryList(muligeSvar, (it) => it.svarId !== selectedCitizenship);
        }
        if (definisjon === 'PM_STATSBORGERSKAP') {
            const selectedSecondaryCitizenship = context.getValue('PM_STATSBORGERSKAP_SEKUNDART')[0];
            return filterCountryList(muligeSvar, (it) => it.svarId !== selectedSecondaryCitizenship);
        }
        return filterCountryList(muligeSvar);
    }, [context, definisjon, muligeSvar]);

    const getSelected = () => {
        const selectedValue = context.getValue(definisjon)[0];
        return Array.isArray(selectedValue) ? DEFAULT_VELG_OPTION_VALUE : selectedValue || DEFAULT_VELG_OPTION_VALUE;
    };

    const hasError = useCallback(
        (value) => {
            if (!value) {
                value = context.getValue(definisjon);
            }
            return value.length === 0 || value === DEFAULT_VELG_OPTION_VALUE;
        },
        [context, definisjon]
    );

    const preselected = getPreselected(question);

    const selected = getSelected();

    const selectValue = useCallback(
        (e) => {
            context.onChange(definisjon, { value: [e], error: hasError(e) });
        },
        [context, definisjon, hasError]
    );

    const handleBlur = useCallback(() => {
        if (selected !== DEFAULT_VELG_OPTION_VALUE && isRequiredWhenSelected(question)) {
            context.updateValidation(definisjon, true, hasError());
        }
    }, [context, definisjon, selected, hasError, question]);

    const removeValue = useCallback(() => {
        context.removeValue(definisjon);
    }, [context, definisjon]);

    return (
        <div className={classNames({ 'has-error error': hasInvalidValue })}>
            <DropDown
                disabled={getIsDisabled(utfyllingsregel.regel, preselected, context.getRolle())}
                className={classNames('form-control', { 'has-error error': hasInvalidValue })}
                values={getDropDownValues()}
                selected={selected}
                label={isSubQuestion ? sporsmalstekst : null}
                errortext={null}
                onBlur={handleBlur}
                placeholder="Start å skrive"
                removeValue={removeValue}
                selectValue={selectValue}
            />
            {hasInvalidValue && <ErrorMessage text={instruks ?? 'Venligst velg fra listen'} />}
        </div>
    );
}

CountrySelectQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(CountrySelectQuestionType));
